export default {"src":"/_next/static/media/pin-green-light-mobile.5ce7e4fd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};